// extracted by mini-css-extract-plugin
module.exports = {"v3japm9":"v3japm9","lyggs4f":"lyggs4f"};